export default {
  "home": {
    "header": {
      "openFull": "Ouvrir en plein écran",
      "settings": "Paramètres de l'accueil",
      "show": "Afficher l'en-tête",
      "hide": "Masquer l'en-tête"
    },
    "empty": {
      "admin": {
        "badge": "Administrateurs de l'organisation seulement",
        "title": "Choisissez ce que {workspaceName} voit en premier",
        "body":
          "L'accueil est la première page que voient tous les membres de cet espace de travail. Choisissez un de ses tableaux de bord IA à afficher ici. Vous pouvez le changer en tout temps dans les paramètres.",
        "cta": "Choisir une mise en page d'accueil",
        "settings": "Paramètres de l'accueil"
      },
      "member": {
        "title": "L'accueil n'est pas encore configuré",
        "body": "Un administrateur de l'organisation choisit le tableau de bord affiché ici. En attendant, tous vos tableaux de bord sont à un clic.",
        "cta": "Parcourir les tableaux de bord"
      },
      "missing": {
        "title": "Le tableau de bord d'accueil n'est plus disponible"
      }
    },
    "picker": {
      "title": "Choisir le tableau de bord d'accueil de {workspaceName}",
      "desc": "Tous les membres de cet espace de travail arrivent sur ce tableau de bord. Les autres espaces de travail gardent leur propre accueil.",
      "search": "Rechercher des tableaux de bord IA",
      "empty": "Aucun tableau de bord IA dans cet espace de travail pour l'instant.",
      "noThumbnail": "Aperçu à venir",
      "updated": "Mis à jour le {date}",
      "note": "Seuls les tableaux de bord IA de cet espace de travail sont listés.",
      "cancel": "Annuler",
      "confirm": "Définir comme accueil"
    },
    "layoutTag": "Mise en page d'accueil",
    "saved": "Tableau de bord d'accueil mis à jour",
    "cleared": "Tableau de bord d'accueil retiré"
  }
};
